import CssBaseline from '@mui/material/CssBaseline';
import AppLayout from 'main/core/AppLayout';
import JWTAuthProvider from 'main/services/auth/jwt-auth/JWTAuthProvider';
import AppContextProvider from 'main/utility/AppContextProvider';
import AppLocaleProvider from 'main/utility/AppLocaleProvider';
import AppStyleProvider from 'main/utility/AppStyleProvider';
import AppThemeProvider from 'main/utility/AppThemeProvider';
import AuthRoutes from 'main/utility/AuthRoutes';
import {initGlobalActivityTracker} from 'main/utility/DebugUtil';
import {useEffect} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import configureStore, {history} from 'redux/store';

const store = configureStore();

const App = () => {
  useEffect(() => {
    initGlobalActivityTracker(history);
  }, []);

  return (
    <AppContextProvider>
      <Provider store={store}>
        <AppThemeProvider>
          <AppStyleProvider>
            <AppLocaleProvider>
              <BrowserRouter history={history}>
                <JWTAuthProvider>
                  <AuthRoutes>
                    <CssBaseline />
                    <AppLayout />
                  </AuthRoutes>
                </JWTAuthProvider>
              </BrowserRouter>
            </AppLocaleProvider>
          </AppStyleProvider>
        </AppThemeProvider>
      </Provider>
    </AppContextProvider>
  );
};

export default App;
